import React from 'react';
import unpick from '../../../utilities/unpick';
import bubbleUpEvents from '../../utilities/bubble-up-events';
import reformatValue from '../../utilities/reformat-value';
import InputMaskWrap from './input-mask-wrapper';

export default function Password(props) {
  const { isValid, onChange, mask, replacePattern, innerRef } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'replacePattern', 'innerRef']);

  const eventProps = replacePattern
    ? {
        onChange(e) {
          bubbleUpEvents(e, [reformatValue(e, replacePattern.regExpString, replacePattern.newSubStr), onChange]);
        },
      }
    : '';

  const inputField = (
    <input
      type="password"
      {...p}
      {...eventProps}
      aria-label={props.ariaLabel || 'Password'}
      aria-placeholder={props.placeholder || ''}
      aria-invalid={!isValid}
      inputMode="text"
      ref={innerRef}
    />
  );

  return mask ? <InputMaskWrap>{inputField}</InputMaskWrap> : inputField;
}

Password.propTypes = {};
